declare global {
  interface Window {
    opr?: any;
    opera?: any;
    chrome?: any;
  }

  interface Navigator {
    brave?: any;
  }
}

export function detectIsMobile(): boolean {
  const userAgent = navigator.userAgent.toLowerCase();

  const mobileKeywords = [
    "android",
    "iphone",
    "ipad",
    "ipod",
    "blackberry",
    "iemobile",
    "opera mini",
    "mobile",
    "windows phone",
    "webos",
    "kindle",
    "silk",
    "tizen"
  ];

  return mobileKeywords.some((keyword) => userAgent.indexOf(keyword) !== -1);
}

export function detectUserBrowser(): string {
  const userAgent = navigator.userAgent.toLowerCase();

  // Chrome detection (excluding Edge and Brave)
  if (
    userAgent.indexOf("chrome") !== -1 &&
    userAgent.indexOf("edg") === -1 &&
    userAgent.indexOf("samsungbrowser") === -1 &&
    !navigator.brave
  ) {
    return "chrome";
  }
  if (userAgent.indexOf("safari") !== -1 && userAgent.indexOf("chrome") === -1) {
    return "safari";
  }
  if (userAgent.indexOf("firefox") !== -1) {
    return "firefox";
  }
  if (userAgent.indexOf("edg") !== -1) {
    return "edge";
  }
  if (userAgent.indexOf("samsungbrowser") !== -1) {
    return "samsungbrowser";
  }
  if (window.opr || window.opera || userAgent.indexOf("opr/") !== -1) {
    return "opera";
  }
  if (userAgent.indexOf("brave") !== -1 || navigator.brave) {
    return "brave";
  }
  if (userAgent.indexOf("vivaldi") !== -1) {
    return "vivaldi";
  }
  if (userAgent.indexOf("msie") !== -1 || userAgent.indexOf("trident") !== -1) {
    return "internet explorer";
  }

  return "other";
}
